/*
 * Phone home rows are one fixed height (ri-home.css; owner, 2026-10-22), so nothing resizes them any more: they
 * used to ease to the tallest cover on screen, which made the page jump as you swiped and as covers loaded.
 * Their covers sit in sideways rows that the browser's lazy loading does not look into until you swipe, so they
 * arrived blank; once the page has loaded, every shelf cover on a phone loads, including ones added later.
 */
(function () {
  var phone = window.matchMedia('(max-width: 749px)');

  function eager(root) {
    if (!phone.matches) return;
    (root || document).querySelectorAll('.ri-home .ri-home-carousel img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function boot() {
    eager();
    if (!window.MutationObserver) return;
    document.querySelectorAll('.ri-home .ri-home-carousel [data-ri-carousel-track]').forEach(function (track) {
      new MutationObserver(function () {
        eager(track);
      }).observe(track, { childList: true });
    });
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
  phone.addEventListener('change', function () {
    eager();
  });
})();

/* Phone home headings that link somewhere: the underline sits under the last line of text only. */
(function () {
  function place() {
    document.querySelectorAll('.ri-home__title-link').forEach(function (link) {
      var range = document.createRange();
      range.selectNodeContents(link);
      var rects = Array.prototype.filter.call(range.getClientRects(), function (r) {
        return r.width > 1;
      });
      if (!rects.length) return;
      var lastTop = rects[rects.length - 1].top;
      var left = Infinity;
      var right = -Infinity;
      rects.forEach(function (r) {
        if (Math.abs(r.top - lastTop) > 2) return;
        left = Math.min(left, r.left);
        right = Math.max(right, r.right);
      });
      var box = link.getBoundingClientRect();
      link.style.setProperty('--ri-ul-left', Math.round(left - box.left) + 'px');
      link.style.setProperty('--ri-ul-width', Math.round(right - left) + 'px');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
  window.addEventListener('resize', place, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
  window.setTimeout(place, 800);
})();
